var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('ul',{staticClass:"tt-footer-nav"},_vm._l((_vm.navLinks),function(menuItem,key){return (_vm.shouldShowMenuItem(menuItem))?_c('li',{key:key},[_c('router-link',{staticClass:"tt-footer-nav__link ff-mont",attrs:{"to":menuItem.url}},[_vm._v(" "+_vm._s(_vm.$t(menuItem.title))+" ")])],1):_vm._e()}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }